var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menubuilder", attrs: { id: "menubuilder" } },
    [
      _c(
        "div",
        { staticClass: "menubuilder__container" },
        [
          _c("LogoUpload"),
          _vm._v(" "),
          _c("CoffeeSelector"),
          _vm._v(" "),
          _c("CustomCoffeeSelector"),
          _vm._v(" "),
          _c("ExtrasSelector"),
          _vm._v(" "),
          _c("TeaSelector"),
          _vm._v(" "),
          _c("OtherSelector"),
          _vm._v(" "),
          _c("CertificationSelector"),
          _vm._v(" "),
          _c("FinalForm", { on: { preview: _vm.togglePreviewPopup } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            title: "Menu Preview",
            className: "wide",
            isOpen: _vm.previewPopupOpen
          },
          on: { toggle: _vm.togglePreviewPopup }
        },
        [
          _c("embed", {
            staticStyle: { "min-height": "calc(100vh - 200px)" },
            attrs: { width: "100%", height: "100%", src: _vm.iframedata }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/MenuBuilder/MenuBuilder.vue?vue&type=template&id=5a48a244&
// module id = 118
// module chunks = 3